module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/no-print-9e090b2187a0ace883280262760493c6.svg";